import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=72ef6f94"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ef6f94')) {
      api.createRecord('72ef6f94', component.options)
    } else {
      api.reload('72ef6f94', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=72ef6f94", function () {
      api.rerender('72ef6f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/bank/Register.vue"
export default component.exports